import * as api from '../../api/api-administracion-caso';
import { 
    OBTENER_LLAVES,
    GET_CONFIG_FORM43,
    GET_DATOS_GESTION_IMPLICADO,
    GET_DATOS_GESTION_IMPLICADO_DEFAULT,
    POST_ACTUALIZAR_EXTRAJUDICIAL,
    GET_CONFIG_FORM39,
    GET_COMBO_INSTANCIAS_PRETENSIONES,
    GET_COMBO_POSIBILIDAD_ACUERDO,
    GET_PRETENSIONES_VIGENTES_IMPLICADO,
    GET_PROVISIONES_VIGENTES_IMPLICADO,
    GET_PRETENSIONES_IMPLICADOS,
    GET_HISTORIAL_PRETENSIONES_IMPLICADO,
    GET_LISTA_IMPLICADOS,
    GET_COMBO_MONEDAS,
    GET_COMBO_INSTANCIAS_PREVISIONES,

    GET_PROVISIONES_IMPLICADOS,
    GET_HISTORIAL_PROVISIONES_IMPLICADO,
    GET_COBERTURA_PROVISIONES,

    GET_TAREAS_PENDIENTES

} from '../types';

export const configuracionFormAction43 = (query) => ({
    type: GET_CONFIG_FORM43,
    payload: api.getConfiguracionForm43(query)
});

export const obtenerListaImplicados = (query) => ({
    type: GET_LISTA_IMPLICADOS,
    payload: api.getListaImplicado(query)
});

export const obtenerDatosGestionImplicado = (query) => ({
    type: GET_DATOS_GESTION_IMPLICADO,
    payload: api.getDatosGestionImpicado(query)
});
export const obtenerDatosGestionImplicadoDefault = (query) => ({
    type: GET_DATOS_GESTION_IMPLICADO_DEFAULT,
    payload: api.getDatosGestionImpicado(query)
});
export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const actualizarGestionDefensa = (newReg) => ({
    type: POST_ACTUALIZAR_EXTRAJUDICIAL,
    payload: api.actualizarGestionDefensa(newReg)
});
export const configuracionFormAction39 = (query) => ({
    type: GET_CONFIG_FORM39,
    payload: api.getConfiguracionForm39(query)
});
export const obtenerComboInstanciaPretensiones = (query) => ({
    type: GET_COMBO_INSTANCIAS_PRETENSIONES,
    payload: api.getComboInstanciaPretensiones(query)
});
export const obtenerComboInstanciaPrevisiones = (query) => ({
    type: GET_COMBO_INSTANCIAS_PREVISIONES,
    payload: api.getComboInstanciaPretensiones(query)
});
export const obtenerComboPosibilidadAcuerdo = (query) => ({
    type: GET_COMBO_POSIBILIDAD_ACUERDO,
    payload: api.getComboPosibilidadAcuerdo(query)
});
export const obtenerPretensionesVigentes = (query) => ({
    type: GET_PRETENSIONES_VIGENTES_IMPLICADO,
    payload: api.getPretensionesVigentesImplicado(query)
});
export const obtenerProvisionesVigentes = (query) => ({
    type: GET_PROVISIONES_VIGENTES_IMPLICADO,
    payload: api.getPretensionesVigentesImplicado(query)
});
export const obtenerPretensionesImplicados = (query) => ({
    type: GET_PRETENSIONES_IMPLICADOS,
    payload: api.getGrillaPretensionesImplicados(query)
});
export const obtenerHistorialPretensiones = (query) => ({
    type: GET_HISTORIAL_PRETENSIONES_IMPLICADO,
    payload: api.getGrillaHistorialPretensionesImplicado(query)
});

export const obtenerProvisionesImplicados = (query) => ({
    type: GET_PROVISIONES_IMPLICADOS,
    payload: api.getGrillaProvisionesImplicados(query)
});
export const obtenerHistorialProvisiones = (query) => ({
    type: GET_HISTORIAL_PROVISIONES_IMPLICADO,
    payload: api.getGrillaHistorialProvisionesImplicado(query)
});
export const obtenerComboMonedas = (query) => ({
    type: GET_COMBO_MONEDAS,
    payload: api.getComboMonedas(query)
});
export const obtenerCoberturaProvisiones = (query) => ({
    type: GET_COBERTURA_PROVISIONES,
    payload: api.getCoberturaProvisiones(query)
});
export const obtenerTareasPendientes = (query) => ({
    type: GET_TAREAS_PENDIENTES,
    payload: api.getTareasPendientes(query)
});